'use client';

import { Users, DollarSign, TrendingUp, BellRing, BarChart3 } from 'lucide-react';
import { StatsCard } from '@/core/presentation/components/StatsCard';
import { kpiData, revenueChartData } from '@/features/admin/presentation/data/mockData';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export function DashboardOverview() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatsCard
          title="Usuários totais"
          value={kpiData.totalUsers.toLocaleString('pt-BR')}
          icon={<Users className="h-5 w-5 text-admin-cyan-dark" />}
          trend={12.5}
          gradient
        />
        <StatsCard
          title="Receita mensal"
          value={`R$ ${(kpiData.revenue / 1000).toFixed(0)}k`}
          icon={<DollarSign className="h-5 w-5 text-admin-cyan-dark" />}
          trend={8.3}
        />
        <StatsCard
          title="Lembretes futuros"
          value={kpiData.futureReminders.toLocaleString('pt-BR')}
          icon={<BellRing className="h-5 w-5 text-admin-cyan-dark" />}
          trend={5.1}
        />
        <StatsCard
          title="Taxa de conversão"
          value={`${kpiData.conversionRate}%`}
          icon={<TrendingUp className="h-5 w-5 text-admin-cyan-dark" />}
          trend={2.4}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">Receita vs Despesas</h3>
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart data={revenueChartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2EAF8" />
              <XAxis dataKey="month" tick={{ fontSize: 12, fill: '#718096' }} />
              <YAxis tick={{ fontSize: 12, fill: '#718096' }} />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="receita"
                stroke="#0D1B5E"
                fill="#0D1B5E"
                fillOpacity={0.1}
              />
              <Area
                type="monotone"
                dataKey="despesas"
                stroke="#7ECFEF"
                fill="#7ECFEF"
                fillOpacity={0.1}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm space-y-4">
          <h3 className="text-sm font-semibold text-admin-text">Resumo rápido</h3>
          <div className="space-y-3">
            {[
              { label: 'Lembretes pendentes', value: kpiData.pendingReminders, icon: BellRing },
              { label: 'Churn rate', value: `${kpiData.churnRate}%`, icon: TrendingUp },
              { label: 'Ticket médio', value: `R$ ${kpiData.avgTicket}`, icon: BarChart3 },
              { label: 'Usuários ativos', value: kpiData.activeUsers.toLocaleString('pt-BR'), icon: Users },
            ].map((item) => (
              <div key={item.label} className="flex items-center justify-between p-3 rounded-lg bg-admin-bg-block">
                <div className="flex items-center gap-2">
                  <item.icon className="h-4 w-4 text-admin-cyan-dark" />
                  <span className="text-sm text-admin-text">{item.label}</span>
                </div>
                <span className="text-sm font-semibold text-admin-text">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

